import styled from 'styled-components';
import { Typography } from '../../../global/theme';
import { ShowVerticalScrollbar } from '../../../global/commonStyle';

const ModalContent = styled.form`
  display: flex;
  flex-direction: column;
  gap: var(--space-24);
  padding: var(--space-16);
`;

const ModalForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-6);
`;

const Label = styled.div`
  ${Typography.body_md_medium}
  color: var(--text-secondary);
`;

const ModalButton = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: var(--space-12);
`;

const DropDiv = styled.div`
  max-height: 186px;
  margin-right: var(--space-4);
  ${ShowVerticalScrollbar}
  &:focus {
    outline: none;
  }
`;
export { ModalContent, ModalForm, Label, ModalButton, DropDiv };
